export default __webpack_public_path__ + "static/media/toolbox.8d2a8f5d.png";